export default "__VITE_ASSET__C$m17RjM__"